<template>
  <div>

    <div v-if="loading">
      <v-skeleton-loader class="mx-auto" max-height="30" type="text"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto" max-height="30" type="text"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto" max-height="30" type="text"></v-skeleton-loader>
    </div>
    <div v-else>
      <div v-if="list_courses">
        <div class="pa-1 bordered rounded bg-grey_3" v-if="list_courses.list.length > 0">
          <v-sheet color="darkblue text-h6 pa-2">Total: {{ total_inscrits }} inscrits <span v-if="total_enfants > 0"> +
              {{
                total_enfants }} enfants</span></v-sheet>

          <div class="pa-1 my-2 bg-white bordered rounded" v-for="course in list_courses.list" :key="course.id">
            <div class="text-body-1 font-weight-bold">{{ course.nom }}</div>
            <div class="text-body-2">
              <div class="d-flex sm-gap mb-2">
                <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0">{{
                  course.nb_inscrits }}<span v-if="course.max_inscrits > 0" class="mr-1">/{{ course.max_inscrits
                  }}</span>
                  inscrits</v-chip>
                <v-chip color="green-darken-4" size="large" density="compact" variant="elevated" elevation="0">{{
                  course.nb_inscrits_valide }}/{{ course.nb_inscrits }} validés</v-chip>
                <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0"
                  v-if="course.nb_enfants > 0">
                  + {{ course.nb_enfants }} enfants
                </v-chip>
                <v-chip
                  v-if="mainStore.module.has_preinscription || mainStore.module.some_races_have_preinscription || mainStore.module.preinscription_ended"
                  color="primary-dark" size="large" density="compact" variant="elevated" elevation="0">
                  {{ course.nb_pre_inscrits }} préinscrits
                </v-chip>
              </div>
              <v-progress-linear rounded :model-value="get_progress(course.nb_inscrits, course.max_inscrits)"
                color="darkblue" height="6"></v-progress-linear>
              <v-progress-linear class="mt-1" rounded
                :model-value="get_progress(course.nb_inscrits_valide, course.max_inscrits, course.nb_inscrits)"
                color="green-darken-1" height="6"> </v-progress-linear>

              <div class="ml-2" v-if="course.vagues && course.vagues.list.length > 0">
                <div class="text-subtitle-2">Remplissage des SAS:</div>
                <div v-for="vague in course.vagues.list" :key="vague.id">
                  <div>
                    {{ vague.nom }} : {{ vague.nb_inscrits }} inscrits <span v-if="vague.nombre > 0">/ {{ vague.nombre
                    }}</span>
                    <v-progress-linear rounded :model-value="get_progress(vague.nb_inscrits, vague.nombre)"
                      color="orange-accent-3" height="5"></v-progress-linear>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <v-sheet elevation="0" class="text-h6 pa-2">Ce module n'a pas de course associée</v-sheet>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import List_Courses from "@/classes/Courses/List_Courses.class.js";
export default {
  props: ['id_module'],
  data() {
    return {
      list_courses: null,
      loading: false,
    };
  },
  watch: {
    id_module: {
      handler: function () {
        if (!this.id_module) return;
        this.loadData();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapStores(useMainStore),
    total_enfants() {
      let total = 0;
      for (let course of this.list_courses.list) {
        if (course.nb_enfants) {
          total += parseInt(course.nb_enfants);
        }

      }
      return total;
    },
    total_inscrits() {
      let total = 0;
      for (let course of this.list_courses.list) {
        total += parseInt(course.nb_inscrits);
      }
      return total;
    },
  },

  methods: {
    get_progress(nb, max_inscrits, replace_max = null) {
      if (nb == 0) return 0;
      if (max_inscrits == 0) {
        if (replace_max) return (nb * 100) / replace_max;
        return 100;
      }
      return (nb / max_inscrits) * 100;
    },

    async loadData() {
      this.loading = true;
      this.list_courses = new List_Courses(this.id_module);
      const has_preinscriptions = this.mainStore.module.has_preinscription || this.mainStore.module.some_races_have_preinscription || this.mainStore.module.preinscription_ended;
      await this.list_courses.fetch_all("stats", has_preinscriptions);
      this.loading = false;

    }
  },

};
</script>

<style lang="scss" scoped></style>